// MegaMenu Watermark
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function () {
    const watermark = document.querySelector('.tmenu-watermark');
    if (watermark) {
      watermark.remove();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

//sticky Header
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header--root");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 250) {
      header.classList.add("header-fixed");
    } else {
      header.classList.remove("header-fixed");
    }
  });
});

// Custom ADD TO CART
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const cartWrapper = e.target.closest('.collection-cart');
    if (!cartWrapper) return;

    const variantInput = cartWrapper.querySelector('.variant-id');
    if (!variantInput) return;

    const variantId = variantInput.value;

    const quickAddWrapper = document.querySelector(`.product-quick-add[data-id="${variantId}"]`);
    if (!quickAddWrapper) return;

    const quickAddButton = quickAddWrapper.querySelector('.product-quick-add--button');
    if (quickAddButton) {
      quickAddButton.click();
    }
  });
});


// // Carousel mouse scroll stop ---------------------------------
// document.addEventListener('DOMContentLoaded', function () {
//   const carouselElements = document.querySelectorAll('carousel-element');

//   carouselElements.forEach(carousel => {
//     const container = carousel.querySelector('.carousel--container');

//     if (!container) return;

//     ['mousedown', 'touchstart', 'pointerdown'].forEach(evt => {
//       container.addEventListener(evt, e => e.preventDefault(), { passive: false });
//     });

//     ['touchmove', 'pointermove', 'mousemove'].forEach(evt => {
//       container.addEventListener(evt, e => e.preventDefault(), { passive: false });
//     });
//   });
// });




// // Slideshow mouse scroll stop
// document.addEventListener('DOMContentLoaded', function () {
//   const slideshowEls = document.querySelectorAll('slideshow-carousel');

//   slideshowEls.forEach(slideshow => {
//     const container = slideshow.querySelector('.carousel--container');

//     if (!container) return;

//     let startX = 0;
//     let startY = 0;
//     let isScrolling = false;

//     container.addEventListener('touchstart', function (e) {
//       startX = e.touches[0].clientX;
//       startY = e.touches[0].clientY;
//       isScrolling = false;
//     }, { passive: true });

//     container.addEventListener('touchmove', function (e) {
//       const dx = e.touches[0].clientX - startX;
//       const dy = e.touches[0].clientY - startY;

//       // If horizontal scroll is more significant than vertical
//       if (Math.abs(dx) > Math.abs(dy)) {
//         // Prevent only horizontal drag to avoid scroll jank
//         e.preventDefault();
//       }
//     }, { passive: false });
//   });
// });


  document.addEventListener("DOMContentLoaded", function () {
    const cartForm = document.querySelector('.cart--form');
    const slides = document.querySelectorAll('.recommendationCant .swiper-slide');

    if (!cartForm || !slides.length) return;

    // Get all class names from the cart form (as plain array)
    const cartClassArray = cartForm.className.split(/\s+/);

    slides.forEach(slide => {
      const slideClassArray = slide.className.split(/\s+/);
      const hasCommonClass = slideClassArray.some(cls => cartClassArray.includes(cls));
      slide.style.display = hasCommonClass ? 'none' : '';
    });
  });



// document.addEventListener('DOMContentLoaded', function () {
//   const scrollLockElements = [
//     { selector: 'slideshow-carousel', child: '.carousel--container' },
//     { selector: 'carousel-element', child: '.carousel--container' }
//   ];

//   scrollLockElements.forEach(({ selector, child }) => {
//     document.querySelectorAll(selector).forEach(wrapper => {
//       const container = wrapper.querySelector(child);
//       if (!container) return;

//       let startX = 0, startY = 0;

//       container.addEventListener('touchstart', function (e) {
//         startX = e.touches[0].clientX;
//         startY = e.touches[0].clientY;
//       }, { passive: true });

//       container.addEventListener('touchmove', function (e) {
//         const dx = e.touches[0].clientX - startX;
//         const dy = e.touches[0].clientY - startY;

//         // Only prevent if swipe is clearly horizontal
//         if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
//           e.preventDefault();
//         }
//       }, { passive: false });
//     });
//   });
// });
// document.addEventListener('DOMContentLoaded', function () {
//   if (window.innerWidth > 767) {
//     const carousels = document.querySelectorAll('carousel-element .carousel--container');

//     carousels.forEach(container => {
//       container.addEventListener('mousedown', e => e.preventDefault(), { passive: false });
//       container.addEventListener('mousemove', e => e.preventDefault(), { passive: false });
//       container.addEventListener('dragstart', e => e.preventDefault(), { passive: false });
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 767) {
    // Disable mouse drag events on all carousel containers
    const containers = document.querySelectorAll('.carousel--container');

    containers.forEach(container => {
      container.style.pointerEvents = 'auto'; // allow click
      container.addEventListener('dragstart', e => e.preventDefault(), { passive: false });
      container.addEventListener('mousedown', e => {
        e.preventDefault(); // prevent drag-scroll
      }, { passive: false });

      container.addEventListener('mousemove', e => {
        e.preventDefault(); // prevent mousemove drag-scroll
      }, { passive: false });
    });
  }
});


  document.addEventListener("DOMContentLoaded", function () {
    const path = window.location.pathname;

    const sectionToShow = document.getElementById("shopify-section-template--24453903089981__custom_liquid_8HkznA");
    const sectionToHide = document.getElementById("shopify-section-template--24453903089981__custom_liquid_xiFKCr");

    if (!sectionToShow || !sectionToHide) return;

    const isAllCollection = path === "/collections/all";

    sectionToShow.style.display = isAllCollection ? "block" : "none";
    sectionToHide.style.display = isAllCollection ? "none" : "block";
  });



  
 const placeholders = [
    "Search by categories",
    "Search by routine",
    "Search by product type"
  ];
  
  const input = document.getElementById("search_input");
  let i = 0;

  setInterval(() => {
    input.placeholder = placeholders[i];
    i = (i + 1) % placeholders.length;
  }, 3000); // Changes every 3 seconds
